import { Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';

@Component({
  selector: 'app-view-accomplishment-details',
  templateUrl: './view-accomplishment-details.component.html',
  styleUrls: ['./view-accomplishment-details.component.scss'],
  standalone: false
})

export class ViewAccomplishmentDetailsComponent implements OnChanges, OnInit {
  //icons
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;

  html = "<p>Hello</p>"

  report = input.required<any>();
  reportList = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  saveSubject = new Subject<any>();

  totalFunding = 0;

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    public readonly reportService: ReportService,
    public readonly accomplishmentService: AccomplishmentService,
  ) {
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.getTotalFunding();
    this.loaded.emit(1);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 2 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.reportList()[0].assessment_id, tab: 2 } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  getTotalFunding() {
    let total = 0;
    this.reportList().forEach((report: any) => {
      report.forests.forEach((forest: ReportForest) => {
        total += this.forestTotal(forest.treatments);
      });
    })
    this.totalFunding = total;
  }

  forestTotal(treatments: any[] | undefined) {
    let total = 0;
    if (treatments == null) return 0
    for (let item of treatments) {
      total += this.unitTotal(item.treatment_specifications[0]) || 0; // ?? Does not cover NaN
    }
    return total;
  }

  unitTotal(item: any) {
    return (item.approved_unit_cost * item.approved_unit_qty) + (item.wo_approved_unit_cost * item.wo_approved_unit_qty);
  }


  save_close() {
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id, tab: 2 } });
  }

  formatDate(date: Date) {
    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year;
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replaceAll(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.codePointAt(0) + ';';
    }));
  }
}
